import React, { useState } from 'react';
import Dialog from './Dialog';
import { IconPeople } from './dialogIcons';
import { supabase } from '../lib/supabase';

export default function OwnershipTransferModal({ count, profile, ownerName, onClose, onSuccess, toast }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  /*
    **The answer was thrown away until 10 September 2026**, and this screen then
    said "Transfer request sent to admin!" whether or not anything had been
    written. A rep would have waited for a sheet nobody had been asked about.
    That is the fault "Stop the silent failures" was written for, still standing
    in one of the places it matters most.
  */
  async function submit() {
    setSubmitting(true);
    const { error } = await supabase.from('todos').insert({
      title:       'Ownership Transfer Request: ' + count.warehouse?.name,
      description: (profile?.full_name || 'A rep') + ' is requesting ownership transfer for ' + count.warehouse?.name,
      priority:    'normal',
      todo_type:   'ownership_transfer',
      // The asking rep's own id, so they can see their request (issue 9, 18
      // September 2026): a rep reads only the tasks that carry it.
      rep_id:      profile?.id || null,
      warehouse_id: count.warehouse?.id,
      count_id:    count.id,
      is_complete: false,
      metadata:    JSON.stringify({
        requesting_rep_id:   profile?.id,
        requesting_rep_name: profile?.full_name,
        requesting_rep_email:profile?.email,
        current_owner_name:  ownerName,
        location_name:       count.warehouse?.name,
        region:              count.warehouse?.region?.name,
        reason:              reason.trim(),
        requested_at:        new Date().toISOString(),
      }),
    });
    setSubmitting(false);
    if (error) {
      toast.error('That request was not sent, so nobody has been asked. Try again.');
      return;
    }
    onSuccess?.();
    onClose();
    toast.success('Your request has gone to an administrator, who decides.');
  }

  return (
    <Dialog
      kind="transfer" icon={<IconPeople />}
      title="Ask for this sheet"
      record={count.warehouse?.name}
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={submit} disabled={submitting}>
            {submitting ? 'Sending...' : 'Send the request'}
          </button>
        </>
      }
    >
      {/* **Who holds it and who is asking, side by side**, from the drawing.
          The old dialog named the holder inside a sentence and never named the
          person asking at all, which is the half an admin needs to decide. */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 14 }}>
        <span style={{ minWidth: 0 }}>
          <span className="form-lbl" style={{ margin: 0, display: 'block' }}>Holds it now</span>
          <span style={{ display: 'block', fontSize: 15, fontWeight: 800, color: 'var(--critical-ink)' }}>{ownerName}</span>
        </span>
        <span style={{ minWidth: 0 }}>
          <span className="form-lbl" style={{ margin: 0, display: 'block' }}>Asking for it</span>
          <span style={{ display: 'block', fontSize: 15, fontWeight: 800, color: 'var(--info-ink)' }}>{profile?.full_name || 'You'}</span>
        </span>
      </div>

      <div style={{ background: 'var(--warning-bg)', borderRadius: 12, padding: '12px 14px', fontSize: 13, color: 'var(--warning-ink)', lineHeight: 1.55 }}>
        {(ownerName || 'Somebody else')} holds this sheet. Your request goes to an admin, who decides.
        Until then you can read it but not count it.
      </div>

      <div className="form-lbl">Why you need it</div>
      <textarea className="form-ta" value={reason} onChange={e => setReason(e.target.value)}
        placeholder="I am covering this practice now, it is on my route." />
      <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 6 }}>Optional, and worth a line.</div>
    </Dialog>
  );
}
